import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UserOnboardingComponent } from '../components/user-onboarding/user-onboarding.component';
import { AppUserState } from '../stores/states/app.state';

@Injectable({
  providedIn: 'root'
})
export class UserOnboardingService {

  constructor(private dialog: MatDialog) { }

  openOnboardingModal(currentUser: AppUserState, options?: { onlyColor?: boolean; }): Observable<string | null> {
    const dialogRef = this.dialog.open(UserOnboardingComponent, {
      width: '600px',
      maxWidth: '90vw',
      disableClose: true,
      panelClass: 'user-onboarding-modal',
      data: { currentUser, onlyColor: options?.onlyColor }
    });

    return dialogRef.afterClosed();
  }
}
